/** Figma configure card width when the configuration layout is at its max width. */
export const CONFIGURE_CARD_MIN_WIDTH_PX = 345.333;

/** Same footprint as agent cards: fill the grid cell, never shorter than 240px. */
export const configureCardSizeClassName =
  'h-full min-h-[240px] w-full min-w-0';

/** 1/2/3 equal-width cols; columns shrink with the container so the grid never overflows. */
export const configureCardGridClassName =
  'grid min-w-0 auto-rows-[240px] grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 [&>*]:h-full [&>*]:w-full [&>*]:min-w-0';
